const images = {
    bg: require('../images/bg.jpeg'),
    logo: require('../images/logo.png'),
    ref: require('../images/ref.png'),
    shild: require('../images/shild.jpg'),
    lock2: require('../images/block_2.png'),
    save_img: require('../images/save_img.png'),
    meta_logo_grey: require('../images/meta-logo-grey.png'),
    star: require('../images/star.png'),
    dir: require('../images/dir.png'),
    fb_round_logo: require('../images/fb_round_logo.png'),
    doc: require('../images/doc.png'),
    fa: require('../images/2FA.png'),
    phone: require('../images/phone.png'),
    meta: require('../images/meta.svg').default,
};
export default images;
